/**
 * WhatsApp Utility Functions
 * Handles redirecting to WhatsApp with product details and images
 */

/**
 * Opens WhatsApp chat with product details and image
 * @param {Object} product - The product details
 * @param {string} product.name - Product name
 * @param {string} product.image - Product image URL
 * @param {string|number} product.price - Product price
 * @param {string} [product.description] - Optional product description
 * @param {Object} [product.specs] - Optional product specifications
 */
export const contactViaWhatsApp = (product) => {
  // WhatsApp phone number (replace with your business number)
  const phoneNumber = "919205894678"; // Format: country code + number without +
  
  // Create message with product details
  let message = `Hello, I'm interested in the following product:\n\n`;
  message += `*${product.name}*\n`;
  
  if (product.price) {
    message += `Price: ${typeof product.price === 'string' ? product.price : `₹${product.price.toLocaleString('en-IN')}`}\n`;
  }
  
  if (product.description) {
    message += `\n${product.description.substring(0, 100)}${product.description.length > 100 ? '...' : ''}\n`;
  }
  
  // Add specifications if available
  if (product.specs) {
    message += '\n*Specifications:*\n';
    Object.entries(product.specs).forEach(([key, value]) => {
      message += `${key}: ${value}\n`;
    });
  }
  
  // Add image reference with clear instructions
  if (product.image) {
    message += `\n*Image:* ${product.image}\n`;
    message += `\n(I've included the image URL above. WhatsApp Web doesn't automatically display images from URLs, but you can view it by clicking the link or copying it to your browser.)\n`;
  }
  
  message += `\nPlease provide more information about this product. I'd like to make a purchase.`;
  
  // Encode the message for URL
  const encodedMessage = encodeURIComponent(message);
  
  // Create WhatsApp URL
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  // Open WhatsApp in a new tab
  window.open(whatsappURL, '_blank');
};

export default contactViaWhatsApp; 